import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import * as actions from '@americanexpress/one-app-ducks';
import { connect } from 'react-redux';
import { ErrorBoundary } from '@americanexpress/axp-manage-bookings-utils/build/components';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { loadLanguagePack, updateLocale } from '@americanexpress/one-app-ducks';
import { IntlProvider } from 'react-intl';

import moduleData from '../../package.json';
import {
  errorMessage, moduleName, ERROR_MSG,
  CONTAINER_MODULE_WRAPPER,
} from '../constants/constants';
import ManageBookingsContainer from './ManageBookingsContainer';

const ContainerWrapper = ({
  locale, languageData, children, addErrorToReport,
}) => {
  const errorData = {
    message: ERROR_MSG,
    moduleName,
    locale,
    customerJourney: `${CONTAINER_MODULE_WRAPPER}`,
  };

  return (
    <IntlProvider locale={locale} messages={languageData}>
      <ErrorBoundary
        errorMessage={errorMessage + locale}
        moduleName={moduleName}
        addErrorToReport={addErrorToReport}
        errorData={errorData}
      >
        <ManageBookingsContainer langPack={languageData}>
          {children}
        </ManageBookingsContainer>
      </ErrorBoundary>
    </IntlProvider>
  );
};

ContainerWrapper.propTypes = {
  locale: PropTypes.string.isRequired,
  languageData: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
  addErrorToReport: PropTypes.func.isRequired,
};

export const loadModuleData = async ({ store: { dispatch }, ownProps }) => {
  const [lang, country] = ownProps.params.locale.split('-');
  await dispatch(updateLocale(`${lang}-${country?.toUpperCase()}`));
  await dispatch(loadLanguagePack(moduleData?.name, { fallbackLocale: 'en-US' }));
};

export const mapDispatchToProps = (dispatch) => ({
  addErrorToReport: (error, otherData) => dispatch(actions.addErrorToReport(error, otherData)),
  dispatch,
});

ContainerWrapper.holocron = {
  name: moduleData?.name,
  loadModuleData,
};

const hocChain = compose(
  oneAppModuleWrapper(moduleData?.name),
  connect(null, mapDispatchToProps)
);

export { ContainerWrapper as TestContainerWrapper };

export default hocChain(ContainerWrapper);
